import * as yup from 'yup';

export const initialValues = {
  person: null,
  reason: '',
};

export const validationSchema = yup.object().shape({
  person: yup.object().required('Assign to person is required'),
  reason: yup.string().required('Reason is required'),
});
